import { useMemo } from "react";

interface Entity {
  id: string;
  createdById?: string;
}

interface Acl {
  create?: "yes" | "no";
  delete?: "all" | "own" | "no";
  edit?: "all" | "own" | "no";
  read?: "all" | "own" | "no";
  stream?: "all" | "own" | "no";
}

interface Permissions {
  canEdit: boolean;
  canDelete: boolean;
}

const getEntityPermissions = (
  entityType: string,
  entity: Entity | null,
  userData: any,
  userId: string
): Permissions => {
  const acl: Acl = userData?.acl?.table?.[entityType] || {};
  const hasUserId = !!userId;

  return {
    canEdit:
      hasUserId &&
      (acl.edit === "all" ||
        (acl.edit === "own" && entity?.createdById === userId)),
    canDelete:
      hasUserId &&
      (acl.delete === "all" ||
        (acl.delete === "own" && entity?.createdById === userId)),
  };
};

const useEntityPermissions = <T extends Entity>(
  entityType: string,
  entities: T[]
): Record<string, Permissions> => {
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const raw = localStorage.getItem("user");
  const userId = raw ? JSON.parse(raw).id : null;

  return useMemo(() => {
    const permissions: Record<string, Permissions> = {};
    entities.forEach((entity) => {
      permissions[entity.id] = getEntityPermissions(
        entityType,
        entity,
        userData,
        userId
      );
    });
    return permissions;
  }, [entities, entityType, userData, userId]);
};

export default useEntityPermissions;
